import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Topbar from "../../components/common/Topbar";
import MobileLogo from "../../components/common/MobileLogo";
import Sidebar from "../../components/common/Sidebar";

import ViewCenterAdmissionReport from "../../components/report/ViewCenterAdmissionReport";
import ViewCourseAdmissionReport from "../../components/report/ViewCourseAdmissionReport";
import ViewAllAdmissionReport from "../../components/report/ViewAllAdmissionReport";
import ViewOldAdmissionReport from "../../components/report/ViewOldAdmissionReport";

import ViewCenterRoyaltyReport from "../../components/report/ViewCenterRoyaltyReport";
import ViewCourseRoyaltyReport from "../../components/report/ViewCourseRoyaltyReport";
import ViewAllRoyaltyReport from "../../components/report/ViewAllRoyaltyReport";

import ViewCenterRevenueReport from "../../components/report/ViewCenterRevenueReport";
import ViewCourseRevenueReport from "../../components/report/ViewCourseRevenueReport";
import ViewAllRevenueReport from "../../components/report/ViewAllRevenueReport";



const ViewReportScreen = (props) => {
  const { report_type } = useParams();

  const [showTopbar, setShowTopbar] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [changeIcon, setChangeIcon] = useState(false);

  const handleShowTopbar = () => {
    setShowTopbar(!showTopbar);
  };
  const handleShowSidebar = () => {
    setShowSidebar(!showSidebar);
  };
  const handleChangeIcon = () => {
    setChangeIcon(!changeIcon);
  };

  const sidebarRef = useRef();
  useEffect(() => {
    let clickToCloseSidebar = (e) => {
      if (sidebarRef.current.contains(e.target)) {
        setShowSidebar(false);
      }
    };

    document.addEventListener("mousedown", clickToCloseSidebar);
    return () => {
      document.removeEventListener("mousedown", clickToCloseSidebar);
    };
  }, []);
  return (
    <>
      <MobileLogo
        handleShowTopbar={handleShowTopbar}
        changeIcon={changeIcon}
        handleChangeIcon={handleChangeIcon}
        handleShowSidebar={handleShowSidebar}
      />

      <Sidebar
        showSidebar={showSidebar}
        handleShowSidebar={handleShowSidebar}
      />
      <Topbar showTopbar={showTopbar} />

      <div className="pc-container" ref={sidebarRef}>
        <div className="pcoded-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="page-header-title">
                    <h5 className="m-b-10">
                      {props.changeUrlToTitle(report_type)} Report
                    </h5>
                  </div>
                </div>
                <div className="col-md-6 text-end">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={"/dashboard"}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={"/reports"}>Reports</Link>
                    </li>
                    <li className="breadcrumb-item">
                      {props.changeUrlToTitle(report_type)}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              {report_type === "center-wise-admissions" && (
                <ViewCenterAdmissionReport {...props} />
              )}
              {report_type === "course-wise-admissions" && (
                <ViewCourseAdmissionReport {...props} />
              )}
              {report_type === "all-admissions" && <ViewAllAdmissionReport {...props} />}

              {report_type === "old-admissions" && <ViewOldAdmissionReport {...props} />}

              {report_type === "center-wise-royalty" && (
                <ViewCenterRoyaltyReport {...props} />
              )}
              {report_type === "course-wise-royalty" && (
                <ViewCourseRoyaltyReport {...props} />
              )}
              {report_type === "all-royalty" && <ViewAllRoyaltyReport {...props} />}

              {report_type === "center-wise-revenue" && (
                <ViewCenterRevenueReport {...props} />
              )}
              {report_type === "course-wise-revenue" && (
                <ViewCourseRevenueReport {...props} />
              )}
              {report_type === "all-revenue" && <ViewAllRevenueReport {...props} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewReportScreen;
